import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
// import DynamicTable from "../../../../components/Dynamic-table";
import DynamicTable from "../../../../components/lab-dynamic-table";

import DeleteConfirmationModal from "../../../../components/Modals/delete-modal";

const SourceTypeTab: React.FC<any> = () => {
  const [editData, setEditData] = useState(null);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState<any>("");
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [loading, setLoading] = useState(false);
  const [dosageData, setDosageData] = useState<any>();
  const [searchInput, setSearchInput] = useState("");
  const [formData, setFormData] = useState({
    sourseTypeName: "",
  });

  const navigate = useNavigate();
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchInput);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchInput]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "name") {
      setFormData((prevState: any) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}/sourse-type/getAllByPagination`,
        {
          params: {
            pageNo: page + 1,
            count: rowsPerPage,
            search: searchInput,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setDosageData(response.data?.data);
      console.log(response.data?.data, "res");
      setTotal(response.data?.totalCount);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditClick = (id: any, rowData: any) => {
    setEditData(id);
    setFormData({
      sourseTypeName: rowData?.sourseTypeName,
    });
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, debouncedSearch]);

  const handleSubmit = async () => {
    if (editData) {
      try {
        const response = await axios.patch(
          `${process.env.REACT_APP_ADMIN_API_URL}/sourse-type/updateById/${editData}`,
          ///stg_lab/collection-type/updateById/{id}
          {
            sourseTypeName: formData?.sourseTypeName,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (!response?.data?.isSuccess) {
          toast.error(response?.data?.message);
        } else {
          toast.success(response?.data?.message);
          setFormData({
            sourseTypeName: "",
          });
          fetchData();
          setEditData(null);
        }
      } catch (error: any) {
        toast.error(error.message || "Something went wrong");
      }
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_ADMIN_API_URL}/sourse-type/addSourseType`,
          {
            sourseTypeName: formData?.sourseTypeName,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (!response?.data?.isSuccess) {
          toast.error(response?.data?.message);
        } else {
          toast.success(response?.data?.message);
          setFormData({
            sourseTypeName: "",
          });
          fetchData();
          setEditData(null);
        }
      } catch (error: any) {
        toast.error(error.message || "Something went wrong");
      }
    }
  };

  const handleDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteClick = (id: any) => {
    setIsDeleteModalOpen(true);
    setSelectedItemId(id);
  };

  const handleDeleteConfirm = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Authorization token is missing");
        return;
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_ADMIN_API_URL}/sourse-type/deleteById/${selectedItemId}`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchData();
      toast.success(response.data.message);
      setFormData({
        sourseTypeName: "",
      });
      setEditData(null);
    } catch (error: any) {
      toast.error(error.message);
    }
    setIsDeleteModalOpen(false);
  };

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(e.target.value);
  };

  return (
    <Box>
      <Box
        sx={{
          borderRadius: 2,
          padding: "1px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: {
              xs: "1rem",
              sm: "1.25rem",
              md: "1.5rem",
            },
          }}
        >
          Source Type
        </Typography>
        <Box display="flex" alignItems="center" gap={1}>
          <TextField
            label="Search"
            placeholder="Search Source Type..."
            variant="outlined"
            value={searchInput}
            // className="search-field"
            className="custom-input"
            onChange={handleSearchInputChange}
            size="small"
            InputProps={{
              endAdornment: (
                <IconButton>
                  <SearchIcon sx={{ color: "#055FFC" }} />
                </IconButton>
              ),
            }}
          />
        </Box>
      </Box>

      <Grid container spacing={1}>
        <Grid item xs={12} sm={4} md={4}>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: 2,
              p: 3,
              boxShadow: 1,
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              {editData ? "Update Source Type" : "Add New Source Type"}
            </Typography>
            <TextField
              size="small"
              // className="search-field"
              className="custom-input"
              label="Source Type Name"
              name="sourseTypeName"
              value={formData?.sourseTypeName}
              fullWidth
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            {/* <TextField
              size="small"
              label="Description"
              // className="search-field"
              className="custom-input"
              name="description"
              type="string"
              value={formData?.description || ""}
              fullWidth
              onChange={handleChange}
              sx={{ mb: 2 }}
            /> */}
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleSubmit}
              disabled={!formData?.sourseTypeName}
            >
              {editData ? "Update" : "Save"}
            </Button>
          </Box>
        </Grid>

        <Grid item xs={12} sm={8} md={8}>
          <DynamicTable
            headers={["SN", "Source Type Name", "Actions"]}
            data={dosageData?.map((item: any, index: any) => [
              page * rowsPerPage + index + 1,
              item?.sourseTypeName || "",
            ])}
            loading={loading}
            page={page}
            rowsPerPage={rowsPerPage}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalRows={total}
            actionButtons={[
              {
                icon: <EditIcon sx={{ color: "#FFB800", cursor: "pointer" }} />,
                onClick: (rowIndex: any) =>
                  handleEditClick(
                    dosageData[rowIndex]?._id,
                    dosageData[rowIndex]
                  ),
              },
              {
                icon: (
                  <DeleteIcon sx={{ color: "#FF5454", cursor: "pointer" }} />
                ),
                onClick: (rowIndex: any) =>
                  handleDeleteClick(dosageData[rowIndex]?._id),
              },
            ]}
            height={"60vh"}
          />
          {dosageData === null && (
            <h1
              style={{
                color: "gray",
                marginTop: "8px",
                textAlign: "center",
                fontSize: "12px",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              No data found
            </h1>
          )}
        </Grid>
      </Grid>

      <DeleteConfirmationModal
        open={isDeleteModalOpen}
        handleClose={handleDeleteModalClose}
        handleConfirm={handleDeleteConfirm}
      />
    </Box>
  );
};

export default SourceTypeTab;
